export { SimpleHistogram } from './SimpleHistogram';
